export default __webpack_public_path__ + "static/media/undraw_online_ad_re_ol62.76f4d76d.svg";